import { z } from 'my-zod'
import { vehicleCheckOutView } from './vehicle-check-out-view'

export const vehicleCheckOutInputView = vehicleCheckOutView.augment({
  checkOutCustomerBase64Signature: z.string().nullable(),
  checkOutStaffBase64Signature: z.string().nullable(),
  operatorId: z.number().nullable()
})

export type vehicleCheckOutInputView = z.infer<typeof vehicleCheckOutInputView>
